import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import QwietAIMappingForm from './QwietAIMappingForm';

function QwietAICredentialsForm(props, ref){
    const fields = [{
        name: "organisationId",
        label: "Organization Id",
        required: true
    }, {
        name: "token",
        label: "Token",
        type: FieldTypes.PASSWORD,
        required: true,
    }]
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={QwietAIMappingForm}
        />
    )
}

export default forwardRef(QwietAICredentialsForm);